import React, { Component } from 'react';
import { FormGroup, ControlLabel, ButtonGroup, Button, HelpBlock } from 'react-bootstrap';
import { Grid, Row, Col } from 'react-bootstrap';

class SelectBox extends Component {

	handleChange(e) {
		this.props.update(e.target.value );
	}

	render() {
		return (
			<Grid>
				<Row>
					<Col>
						<form>
							<FormGroup
								controlId="formBasicDate"
							>
								<ControlLabel style={{display:'block'}}>Tipologia</ControlLabel>
								<ButtonGroup>
									<Button active={this.props.selected===1?true:false} onClick={this.props.update.bind(this, 1)}>Tutti</Button>
									<Button active={this.props.selected===2?true:false} onClick={this.props.update.bind(this, 2)}>Seguiti</Button>
									<Button active={this.props.selected===3?true:false} onClick={this.props.update.bind(this, 3)}>Ricerche</Button>
								</ButtonGroup>
								<HelpBlock>Tra i twitter seguiti o da ricerca generica</HelpBlock>
							</FormGroup>
						</form>
					</Col>
				</Row>
			</Grid>
		);
	}
}

export default SelectBox;



// WEBPACK FOOTER //
// ./src/components/SelectBox.js